import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { WebsiteFormApiParameter, websiteFormService } from "@tSurya/Services/WebsiteRegistrationService";

type HandlerType = ApiHandler<WebsiteFormApiParameter & HasOnSuccess<WebsiteFormApiParameter>, any>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    const result = await websiteFormService(props.apiParameter);
    if (result.successful) {
        props.apiResult = result.result;
    } else {
        props.parameter.onError?.(result.errorMessage);
        return false;
    }
};
export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [PopulateApiParameter, RequestDataFromApi, ExecuteOnSuccessCallback];

const submitWebsiteForm = createHandlerChainRunner(chain, "submitWebsiteForm");
export default submitWebsiteForm;
